import styled from "styled-components";
import { styledByTheme } from "../../../../themes/architecture/styled-by-theme";

const VoucherCardDefaultSideBox = styled.div<{backgroundImageUrl: string; backSideShown: boolean;}>`
    position: absolute;
    display: flex;
    flex-direction: column;

    background-image: url("${props => props.backgroundImageUrl}");
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    color: ${({ theme }) => theme.colors.textContrast};
    width: 100%;
    box-sizing: border-box;
    height: 100%;
    transition: transform 0.6s;
    backface-visibility: hidden;
    padding: 10px 20px 20px 20px;
`;

const VoucherCard777SideBox = styled(VoucherCardDefaultSideBox)`
    color: unset;
`;

export const VoucherCardSideBox = styledByTheme(VoucherCardDefaultSideBox).forCasino777(VoucherCard777SideBox).apply();